import { useIsPredictionsProduct } from '@/hooks/use-is-predictions-product';

import { getPredictionBetCost } from '../utils/prediction-cost';
import { Bet } from './types';

// What the bet cost the user: the actual prediction cost once the order fills, the debited stake otherwise.
export const useBetCost = (bet: Bet): number => {
    const isPredictions = useIsPredictionsProduct();
    return isPredictions ? getPredictionBetCost(bet) : bet.stake;
};
